import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

/**
 * Filter controls for searching and filtering companies
 */
const CompanyFilters = ({ searchQuery, setSearchQuery, statusFilter, setStatusFilter }) => {
  const navigate = useNavigate();

  const statusOptions = [
    { value: 'all', label: 'All Status' },
    { value: 'active', label: 'Active Only' },
    { value: 'inactive', label: 'Inactive Only' }
  ];

  return (
    <div className="p-6 border-b border-border">
      <div className="flex flex-col lg:flex-row gap-4 mb-6">
        <div className="flex-1">
          <Input
            type="search"
            placeholder="Search by company name or slug..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e?.target?.value)}
          />
        </div>
        <div className="w-full lg:w-64">
          <Select
            options={statusOptions}
            value={statusFilter}
            onChange={setStatusFilter}
            placeholder="Filter by status"
          />
        </div>
        <Button
          variant="outline"
          onClick={() => navigate('/global-defaults-management')}
          iconName="Settings"
          iconPosition="left"
          iconSize={16}
        >
          Global Defaults
        </Button>
      </div>
    </div>
  );
};

export default CompanyFilters;